export default "__VITE_ASSET__1d57877c__"